import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "container" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-info",
  role: "alert"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  style: {"margin-bottom":"40px"}
}
const _hoisted_11 = { class: "fg-color-blue" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  class: "col-sm-6",
  style: {"margin-bottom":"20px"}
}
const _hoisted_14 = { class: "card bg-light" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "card-title" }
const _hoisted_19 = { class: "card-text" }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { class: "fg-color-blue" }
const _hoisted_22 = { class: "table table-striped table-hover" }
const _hoisted_23 = ["onClick"]

import { computed, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    import
        {
            useCurrentUserQueryV1,
            useUserQueryV1
        } from '@Organizations/Users/queries-vue-composables'

    import
        {
            useWorkspacesByUserQueryV1,
            useWorkspacesByOrganizationQueryV1
        } from '@Organizations/Workspaces/queries-vue-composables'

    import
        {
            useAddUserToWorkspaceCommandV1,
            useRemoveUserFromWorkspaceCommandV1
        } from '@Organizations/Workspaces/commands-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageUserWorkspacesPage',
  setup(__props) {

    const route = useRoute()
    const userId = computed(() => String(route.params.id))

    const { runCurrentUserQueryV1 } = useCurrentUserQueryV1(false, true, false)

    const { runUserQueryV1, modelUserQueryV1: user } = useUserQueryV1(userId)

    const {
        runWorkspacesByUserQueryV1,
        modelWorkspacesByUserQueryV1: userWorkspacesModel
    } = useWorkspacesByUserQueryV1(userId)

    const {
        runWorkspacesByOrganizationQueryV1,
        modelWorkspacesByOrganizationQueryV1: organizationWorkspacesModel
    } = useWorkspacesByOrganizationQueryV1()

    // ---------------- derived ----------------

    const email = computed(() => user.value?.Email)
    const isServiceUser = computed(() => user.value?.IsServiceUser ?? false)
    const organizationUnitId = computed(() => user.value?.OrganizationUnitId)

    const userWorkspaces = computed(() => userWorkspacesModel.value?.Workspaces ?? [])
    const organizationWorkspaces = computed(() => organizationWorkspacesModel.value?.Workspaces ?? [])
    const organizationWorkspacesLoaded = computed(() => organizationWorkspacesModel.value != null)
    const organizationWorkspacesLength = computed(() => organizationWorkspaces.value.length)

    // combine org + user workspaces
    const workspaces = computed(() =>
        organizationWorkspaces.value.map((w: any) => ({
            ...w,
            Exists: userWorkspaces.value.some(
                (uw: any) => uw.WorkspaceId === w.WorkspaceId
            )
        }))
    )

    const userInWorkspaces = computed(() => workspaces.value.filter((w: any) => w.Exists))

    const userNotInWorkspaces = computed(() => workspaces.value.filter((w: any) => !w.Exists))

    // ---------------- commands ----------------

    const { invokeAddUserToWorkspaceCommandV1, succeedAddUserToWorkspaceCommandV1 } =
        useAddUserToWorkspaceCommandV1()

    const { invokeRemoveUserFromWorkspaceCommandV1, succeedRemoveUserFromWorkspaceCommandV1 } =
        useRemoveUserFromWorkspaceCommandV1()

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = "Manage user's workspaces"
        runCurrentUserQueryV1()
        runUserQueryV1()
        runWorkspacesByUserQueryV1()
    })

    // ---------------- watchers ----------------

    watch(organizationUnitId, (ouId) =>
    {
        if (ouId)
        {
            runWorkspacesByOrganizationQueryV1({ tenantId: ouId })
        }
    })

    // Vue 2 succeedAnyCommand → refresh user workspaces
    watch(
        [
            succeedAddUserToWorkspaceCommandV1,
            succeedRemoveUserFromWorkspaceCommandV1
        ],
        (states) =>
        {
            if (states.some(Boolean))
            {
                runWorkspacesByUserQueryV1()
            }
        }
    )

    // ---------------- handlers ----------------

    function handleAddUserToWorkspaceCommandV1(workspace: any)
    {
        invokeAddUserToWorkspaceCommandV1({ id: workspace.WorkspaceId, userId: userId })
    }

    function handleRemoveUserFromWorkspaceCommandV1(workspace: any)
    {
        const type = isServiceUser.value ? 'service account' : 'user'
        if (window.confirm(`Do you want to remove ${type} ${email.value} from workspace?`))
        {
            invokeRemoveUserFromWorkspaceCommandV1({ id: workspace.WorkspaceId, userId: userId })
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (organizationUnitId.value)
        ? (_openBlock(), _createBlock(AdminNavigationV2, {
            key: 0,
            tid: organizationUnitId.value
          }, null, 8 /* PROPS */, ["tid"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(isServiceUser.value ? "Manage service account's workspaces" : "Manage user's workspaces"), 1 /* TEXT */),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/manage/${userId.value}`,
            class: "btn btn-link btn-sm"
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_6)
        ])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_7, [
      _createCommentVNode(" Informational alert for service accounts "),
      (isServiceUser.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "fa fa-info-circle",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("strong", null, "Service Account Workspaces:", -1 /* CACHED */),
            _createTextVNode(" Workspace assignments control which workspaces this service account can access through the API. Service accounts use API keys for authentication instead of passwords. ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (organizationWorkspacesLoaded.value && organizationWorkspacesLength.value==0)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_9, "No workspaces available"))
        : _createCommentVNode("v-if", true),
      (userNotInWorkspaces.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h4", _hoisted_11, _toDisplayString(isServiceUser.value ? 'Grant access to workspaces' : 'Invite user to workspaces'), 1 /* TEXT */),
            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userNotInWorkspaces.value, (w) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createTextVNode(_toDisplayString(isServiceUser.value ? 'Workspace access' : 'Workspace invitation') + " ", 1 /* TEXT */),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (handleAddUserToWorkspaceCommandV1(w)),
                        class: "btn btn-primary btn-sm pull-right"
                      }, [
                        _createTextVNode(_toDisplayString(isServiceUser.value ? 'Grant' : 'Send') + " ", 1 /* TEXT */),
                        _createElementVNode("i", {
                          class: _normalizeClass([isServiceUser.value ? 'fa fa-check' : 'fa fa-send-o']),
                          "aria-hidden": "true"
                        }, null, 2 /* CLASS */)
                      ], 8 /* PROPS */, _hoisted_16)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h5", _hoisted_18, _toDisplayString(w.Name), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_19, [
                        _createElementVNode("em", null, _toDisplayString(w.Decription), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (userInWorkspaces.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("h4", _hoisted_21, _toDisplayString(isServiceUser.value ? "Service account's workspaces" : "User's workspaces"), 1 /* TEXT */),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("table", _hoisted_22, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userInWorkspaces.value, (w) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(w.Name), 1 /* TEXT */),
                    _createElementVNode("th", null, _toDisplayString(w.Decription), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (handleRemoveUserFromWorkspaceCommandV1(w)),
                        class: "btn btn-secondary btn-sm pull-right"
                      }, _toDisplayString(isServiceUser.value ? 'Revoke access' : 'Remove an access'), 9 /* TEXT, PROPS */, _hoisted_23)
                    ])
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})